import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { CategoryCard, ProductCard } from 'components/rich';
import { couponSale } from 'ecommerce/lib/coupon';
import categoryProduct from '../../lib/categoryProduct';

const CatalogCategoryCard = forwardRef(({ category, previewSummary, ...props }, ref) => {
  const product = categoryProduct(category);
  if (!product) return <CategoryCard ref={ref} {...props} category={category} />;

  return (
    <ProductCard
      ref={ref}
      {...props}
      product={product}
      imagePrefix=""
      startingAt
      sale={couponSale(previewSummary, product)}
    />
  );
});

CatalogCategoryCard.propTypes = {
  category: PropTypes.object.isRequired,
  previewSummary: PropTypes.object,
};

export default CatalogCategoryCard;
